import { config } from "@/config";
import { Provider } from "@/providers/http.provider";

export const getStorageFileUrl = (photo: string): string => {
  return `${config.baseAPIUrl}/rest/files/${encodeURIComponent(photo)}?lasso-token=${localStorage.getItem("lassoToken") ?? Provider.token}`;
};
